import Table from 'bam-node-savant-table/table-ts.ts'
import React from 'react'
import ReactDOM from 'react-dom'
import FilterApp from './percentile-ranking/FilterApp.tsx'
import type { PercentileRankingsRow } from './percentile-ranking/types.ts'

export default function setupApp(table: Table<PercentileRankingsRow>) {
    const el = document.getElementById('filter-app')

    ReactDOM.render(<FilterApp table={table} />, el)
}
